module.exports = __webpack_public_path__ + "static/media/pms_pro.896e658a.png";